import React from 'react';

export default function FontSizeControl({ value, onChange, id = 'font-size' }) {
  const handleChange = (e) => {
    const v = e.target.value;
    if (v === '') return onChange('');
    const n = Number(v);
    if (!Number.isNaN(n)) onChange(n);
  };

  const handleBlur = () => {
    const min = 6;
    const max = 300;
    let n = Number(value);
    if (Number.isNaN(n) || value === '') n = 20; // default
    if (n < min) n = min;
    if (n > max) n = max;
    onChange(n);
  };

  return (
    <div className="flex items-center gap-2 snap-center">
      <label htmlFor={id} className="text-sm text-gray-600">
        Font size
      </label>
      <input
        id={id}
        type="number"
        inputMode="numeric"
        min={6}
        max={300}
        step={1}
        value={value === '' ? '' : Number(value)}
        onChange={handleChange}
        onBlur={handleBlur}
        className="w-24 rounded-lg border border-gray-300 px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
        aria-label="Font size in pixels"
      />
      <span className="text-xs text-gray-500">px</span>
    </div>
  );
}
